import { render, staticRenderFns } from "./modern-contemporary-5.vue?vue&type=template&id=a51fd41c"
import script from "./modern-contemporary-5.vue?vue&type=script&lang=js"
export * from "./modern-contemporary-5.vue?vue&type=script&lang=js"
import style0 from "./modern-contemporary-5.vue?vue&type=style&index=0&id=a51fd41c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports